import React, {Fragment} from 'react';
import {PeopleEditCommon} from './PeopleEditCommon';
import SystemSettingsEditPalletTracker from "./SystemSettingsEditPalletTracker";



const SystemSettingsEdit = (props) => {

    const settingsId = props.settingsId;

    if (settingsId == SystemSettingsEditPalletTracker.settingsId) {
        return SystemSettingsEditPalletTracker(props);
    }
    else {
        return (<div>Unknown settings {props.settingsId}</div>)
    }

}


export default SystemSettingsEdit;